import fs from "fs";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-xhr-backend";
import moment from "moment";
import numeral from "numeral";
import { initReactI18next  } from "react-i18next";

function loadLocales(url, options, callback, data) {
  try {
    if (process.env.__Electron__) {
      fs.readFile(
        `./locales/${url}.json`,
        (err, locale) =>
          err ? callback(null, { status: "404" }) : callback(locale.toString("utf8"), { status: "200" })
      );
    } else {
      import(`./locales/${url}.json`)
        .then((raw: any) => {
          const text = typeof raw === "string" ? raw : (raw?.default ?? raw);
          callback(JSON.parse(text), { status: "200" });
        })
        .catch(() => callback(null, { status: "404" }));
    }
  } catch (e) {
    callback(null, { status: "404" });
  }
}

i18n
  .use(Backend)
  .use(initReactI18next )
  .init({
    fallbackLng: "en",
    load: "languageOnly",
    lng: "en",                         // FORCE English 
    supportedLngs: ["en"],             // only allow en
    nonExplicitSupportedLngs: true,    // en-US -> en
    // have a common namespace used around the full app
    ns: ["translations"],
    defaultNS: "translations",

    debug: false, // !!process.env.__DEV__,

    initImmediate: !process.env.__DEV__, // do not init immediate if dev (load synchronously)

    interpolation: {
      escapeValue: false, // not needed for react
      formatSeparator: ",",
      format: function(value, format, lng) {
        if (value instanceof Date) return moment(value).format(format);
        if (moment.isMoment(value)) return value.format(format);
        if (!Number.isNaN(value)) return numeral(value).format(format);
        return value;
      }
    },

    react: {
      wait: !!process.env.__DEV__
    },

    backend: {
      loadPath: "en",
      parse: data => data,
      ajax: loadLocales
    }
  });

// numeral must be initialized. default to english.
numeral.locale("en");

i18n.on("languageChanged", function(lng) {
  moment.locale(lng);

  if (lng === "en" || lng === "en-US") {
    // English is baked into numeral and doesn't need to be loaded.
    numeral.locale(lng);
  } else {
    require("promise-loader?global!numeral/locales/" + lng + ".js")().then(locale => {
      numeral.locale(lng);
      console.log("Async load of '%s' numeral locale.", lng);
    });
  }
});

export default i18n;
